import styled from "@emotion/styled";
import Button from "global/components/atomic/Button";

export const ExternalLink = styled(Button)`
  svg {
    rotate: -45deg;
  }
`;
